




import React, { useState, useEffect } from 'react';
import { ref, onValue, off } from 'firebase/database';
import { database } from '../firebase';

const WebsiteNotificationBar = () => {
  const [notifications, setNotifications] = useState([]);
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0);
  const [showNotification, setShowNotification] = useState(true);

  useEffect(() => {
    const notificationsRef = ref(database, 'school/notifications');
    
    onValue(notificationsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const activeNotifications = Object.values(data)
          .filter(notif => notif.isActive)
          .filter(notif => {
            const now = new Date();
            const start = new Date(notif.startDate);
            const end = notif.endDate ? new Date(notif.endDate) : null;
            return now >= start && (!end || now <= end);
          });
        setNotifications(activeNotifications);
        setCurrentNotificationIndex(0); // Reset to first notification when list changes
      } else {
        setNotifications([]);
      }
    });

    return () => off(notificationsRef);
  }, []);

  // Cycle through notifications every 10 seconds
  useEffect(() => {
    if (notifications.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentNotificationIndex(prev => 
        prev >= notifications.length - 1 ? 0 : prev + 1
      );
    }, 10000); // Change notification every 10 seconds

    return () => clearInterval(timer);
  }, [notifications]);

  if (notifications.length === 0) return null;

  const currentNotification = notifications[currentNotificationIndex];

  return (
    <div style={{
      backgroundColor: '#f3f4f6',
      padding: '0.75rem',
      position: 'relative',
      overflow: 'hidden',
      borderBottom: '1px solid #e5e7eb'
    }}>
      {/* Left border colored by notification type */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '4px',
        backgroundColor: 
          currentNotification.type === 'info' ? '#3b82f6' :
          currentNotification.type === 'warning' ? '#f59e0b' :
          currentNotification.type === 'alert' ? '#ef4444' :
          '#10b981'
      }}></div>
      
      <div style={{ 
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '1rem'
      }}>
        {/* Icon based on notification type */}
        <svg
          style={{
            width: '1.25rem',
            height: '1.25rem',
            marginRight: '0.75rem',
            color: 
              currentNotification.type === 'info' ? '#3b82f6' :
              currentNotification.type === 'warning' ? '#f59e0b' :
              currentNotification.type === 'alert' ? '#ef4444' :
              '#10b981',
            flexShrink: 0
          }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {currentNotification.type === 'info' && (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          )}
          {currentNotification.type === 'warning' && (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          )}
          {currentNotification.type === 'alert' && (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          )}
          {currentNotification.type === 'success' && (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          )}
        </svg>
        
        {/* Scrolling notification text */}
        {/* <div style={{ 
          whiteSpace: 'nowrap',
          animation: 'scroll 15s linear infinite',
          fontSize: '1.5rem',
          fontWeight: '500',
          flexGrow: 1
        }}>
          {currentNotification.text}
        </div> */}

        <div style={{
  whiteSpace: 'nowrap',
  animation: 'scroll 15s linear infinite, colorChange 8s linear infinite',
  fontSize: '1.5rem',
  fontWeight: '700',
  flexGrow: 1,
  background: 'linear-gradient(90deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #9400d3)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
  backgroundSize: '600% 100%',
  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  padding: '0.25rem 0',
  WebkitTextStroke: '1px rgba(255,255,255,0.3)'
}}>
  {currentNotification.text}
</div>

<style>{`
  @keyframes scroll {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }
  
  @keyframes colorChange {
    0% { background-position: 0% 50%; }
    100% { background-position: 100% 50%; }
  }
`}</style>
        
        {/* Notification counter (if multiple notifications) */}
        {notifications.length > 1 && (
          <div style={{
            marginLeft: '1rem',
            padding: '0.25rem 0.5rem',
            borderRadius: '9999px',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            fontSize: '0.75rem',
            fontWeight: '600',
            flexShrink: 0
          }}>
            {currentNotificationIndex + 1}/{notifications.length}
          </div>
        )}
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );



};

export default WebsiteNotificationBar;